import "core-js/modules/es.object.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addReplenishment } from "@/api/kamitaku/kamitaku";
import { serchSelect } from "@/mixins/index";
import pickerOption from '@/mixins/module/pickerOption';
export default {
  mixins: [pickerOption, serchSelect],
  data: function data() {
    return {
      searchData: {
        special_product_id: "",
        server_id: '',
        device_id: '',
        user_id: '',
        role_id: '',
        order_id: '',
        level: '',
        amount: '',
        currency: '',
        product_id: '',
        product_name: '',
        ip: '',
        timestamp: ''
      },
      dialogShow: false,
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      rules: {
        special_product_id: [{
          required: true,
          message: this.$t('selectProduct'),
          trigger: "blur"
        }],
        server_id: [{
          required: true,
          message: this.$t('pleaseInputServerId'),
          trigger: "blur"
        }],
        device_id: [{
          required: true,
          message: this.$t('pleaseInputDeviceId'),
          trigger: "blur"
        }],
        user_id: [{
          required: true,
          message: this.$t('pleaseInputAccountId'),
          trigger: "blur"
        }],
        role_id: [{
          required: true,
          message: this.$t('pleaseInputRoleId'),
          trigger: "blur"
        }],
        order_id: [{
          required: true,
          message: this.$t('pleaseInputOrderNo'),
          trigger: "blur"
        }],
        // level:[{ required: true, message: "请输入等级", trigger: "blur" }],
        // currency:[{ required: true, message: "请输入货币类型", trigger: "blur" }],
        amount: [{
          required: true,
          message: this.$t('pleaseInputAmountCents'),
          trigger: "blur"
        }],
        product_id: [{
          required: true,
          message: this.$t('pleaseInputProductId'),
          trigger: "blur"
        }],
        product_name: [{
          required: true,
          message: this.$t('pleaseInputProductName'),
          trigger: "blur"
        }],
        ip: [{
          required: true,
          message: this.$t('pleaseInputRechargeUserIp'),
          trigger: "blur"
        }],
        timestamp: [{
          required: true,
          message: this.$t('pleaseSelectRechargeTime'),
          trigger: "blur"
        }]
      },
      issubmit: false
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      this.dialogShow = true;
    },
    clearData: function clearData() {
      this.searchData = {
        special_product_id: this.rawData.game_show_type == 1 ? '' : this.searchData.special_product_id,
        server_id: '',
        device_id: '',
        user_id: '',
        role_id: '',
        order_id: '',
        level: '',
        amount: '',
        currency: '',
        product_id: '',
        product_name: '',
        ip: '',
        timestamp: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this.issubmit = true;
          var data = JSON.parse(JSON.stringify(_this.searchData));
          data.timestamp = data.timestamp / 1000;
          addReplenishment(data).then(function (res) {
            if (res.status == 200) {
              _this.$message({
                message: _this.$t('operationSuccess'),
                type: 'success'
              });

              _this.dialogShow = false;
            }
          }).finally(function () {
            _this.issubmit = false;
          });
        }
      });
    }
  }
};